import clsx from 'clsx';
import { chartDefFormatter } from '../Formatters';
import { useTooltipStyles } from '../ChartTooltipStyles';
import TimeAndStatus from './TimeAndStatus';

const overTheshold = (value, threshold, inverted) => {
    if (inverted) {
        return value <= threshold;
    }

    return value >= threshold;
};

export default function CustomTooltip({ chartDef, timeslice }) {
    const classes = useTooltipStyles();
    if (!timeslice) return null;
    const metrics = {};
    timeslice.items.forEach((item) => {
        const { key } = item.def;
        metrics[key] = item;
    });
    return (
        <div>
            <TimeAndStatus chartDef={chartDef} timeslice={timeslice} />

            <table className={classes.tooltipTable}>
                <tbody>
                    <tr>
                        <td colSpan="3" />
                        <td className={classes.thresholdTooltipHeader}>Degraded</td>
                        <td className={classes.thresholdTooltipHeader}>Excessive</td>
                    </tr>

                    {timeslice.items
                        .filter((item) => !item.def.hidden)
                        .map((item) => {
                            const { def } = item;
                            const degradedItem = metrics[def.degraded];
                            const excessiveItem = metrics[def.excessive];
                            const degraded = degradedItem
                                ? overTheshold(item.value, degradedItem.value, def.inverted)
                                : undefined;
                            const excessive = excessiveItem
                                ? overTheshold(item.value, excessiveItem.value, def.inverted)
                                : undefined;
                            let thresholdClass;
                            if (excessive) {
                                thresholdClass = classes.thresholdExcessive;
                            } else if (degraded) {
                                thresholdClass = classes.thresholdDegraded;
                            } else {
                                thresholdClass = classes.thresholdNormal;
                            }
                            return (
                                <tr key={def.key} className={clsx(classes.tooltipPoint, thresholdClass)}>
                                    <td>
                                        <div
                                            className={classes.tooltipPointColorBox}
                                            style={{ backgroundColor: item.def.color }}
                                        />
                                    </td>
                                    <td className={classes.tooltipPointLabel}>{item.def.label}:</td>
                                    <td className={classes.tooltipPointValue}>
                                        {chartDefFormatter(item.def, item.value)}
                                    </td>
                                    {degradedItem && (
                                        <td className={classes.tooltipPointThreshold}>
                                            {chartDefFormatter(item.def, degradedItem.value)}
                                        </td>
                                    )}
                                    {excessiveItem && (
                                        <td className={classes.tooltipPointThreshold}>
                                            {chartDefFormatter(item.def, excessiveItem.value)}
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
    );
}
